import { cva } from 'class-variance-authority';

export const FEATURED_ICON_ID_CLASSNAME = 'ua-featured-icon';

export const featuredIconVariants = cva(
  `flex items-center justify-center flex-shrink-0 border ${FEATURED_ICON_ID_CLASSNAME}`,
  {
    variants: {
      size: {
        xxs: 'size-5 rounded-xs',
        xs: 'size-6 rounded-sm',
        sm: 'size-8 rounded-sm',
        md: 'size-10 rounded-lg',
        lg: 'size-12 rounded-lg',
        xl: 'size-14 rounded-xl',
        '2xl': 'size-[3.875rem] rounded-xl',
      },
      color: {
        white: 'bg-white border-tertiary',
        clear: '',
        gray: 'bg-utility-gray-50 border-utility-gray-100',
        brand:
          'bg-utility-brand-50 border-utility-brand-100 is-platform:bg-utility-brand-secondary-50 is-platform:border-transparent',
        'brand-secondary':
          'bg-utility-brand-secondary-50 border-utility-brand-secondary-100 is-platform:border-transparent',
        error: 'bg-utility-error-50 border-utility-error-100',
        warning: 'bg-utility-warning-50 border-utility-warning-100',
        success: 'bg-utility-success-50 border-utility-success-100',
        'blue-light': 'bg-utility-blue-light-50 border-utility-blue-light-100',
        blue: 'bg-utility-blue-50 border-utility-blue-100',
        indigo: 'bg-utility-indigo-50 border-utility-indigo-100',
        purple: 'bg-utility-purple-50 border-utility-purple-100',
        violet: 'bg-utility-violet-50 border-utility-violet-100',
        fuchsia: 'bg-utility-fuchsia-50 border-utility-fuchsia-100',
        cyan: 'bg-utility-cyan-50 border-utility-cyan-100',
        lime: 'bg-utility-lime-50 border-utility-lime-100',
        pink: 'bg-utility-pink-50 border-utility-pink-100',
        orange: 'bg-utility-orange-50 border-utility-orange-100',
        transparent: 'bg-transparent border-transparent',
      },
    },
    compoundVariants: [
      {
        color: 'clear',
        className: 'border-none',
      },
    ],
  },
);

export const featuredIconIconVariants = cva('', {
  variants: {
    size: {
      xxs: 'size-3',
      xs: 'size-4',
      sm: 'size-5',
      md: 'size-6',
      lg: 'size-7',
      xl: 'size-8',
      '2xl': 'size-9',
    },
    color: {
      white: 'text-icon-primary',
      clear: 'text-icon-primary',
      gray: 'text-icon-primary',
      brand: 'text-icon-brand is-platform:text-icon-primary',
      'brand-secondary': 'text-icon-primary',
      error: 'text-icon-error',
      warning: 'text-icon-warning',
      success: 'text-icon-success',
      'blue-light': 'text-utility-blue-light-600',
      blue: 'text-utility-blue-600',
      indigo: 'text-utility-indigo-600',
      purple: 'text-utility-purple-600',
      violet: 'text-utility-violet-600',
      fuchsia: 'text-utility-fuchsia-600',
      cyan: 'text-utility-cyan-600',
      lime: 'text-utility-lime-600',
      pink: 'text-utility-pink-600',
      orange: 'text-utility-orange-600',
      transparent: 'text-utility-gray-500',
    },
  },
});

export type SolidFeaturedIconColor =
  | 'gray'
  | 'brand'
  | 'brand-secondary'
  | 'error'
  | 'warning'
  | 'success';

export const solidFeaturedIconVariants = cva(
  `flex items-center justify-center flex-shrink-0 border border-transparent ${FEATURED_ICON_ID_CLASSNAME}`,
  {
    variants: {
      size: {
        xxs: 'size-5 rounded-xs',
        xs: 'size-6 rounded-sm',
        sm: 'size-8 rounded-sm',
        md: 'size-10 rounded-lg',
        lg: 'size-12 rounded-lg',
        xl: 'size-14 rounded-xl',
        '2xl': 'size-[3.875rem] rounded-xl',
      },
      color: {
        gray: 'bg-utility-gray-500',
        brand: 'bg-utility-brand-500 is-platform:bg-[var(--palette-brand-500)]',
        'brand-secondary': 'bg-utility-brand-secondary-800',
        error: 'bg-utility-error-500',
        warning: 'bg-utility-warning-500',
        success: 'bg-utility-success-500',
      },
    },
  },
);

// solid glyph is white and half the chip (figma: 12px glyph in the 24px xs chip)
export const solidFeaturedIconIconVariants = cva('text-white', {
  variants: {
    size: {
      xxs: 'size-2.5',
      xs: 'size-3',
      sm: 'size-4',
      md: 'size-5',
      lg: 'size-6',
      xl: 'size-7',
      '2xl': 'size-8',
    },
  },
});

export const notificationsFeaturedIconVariants = cva(
  `flex items-center justify-center flex-shrink-0 ${FEATURED_ICON_ID_CLASSNAME}`,
  {
    variants: {
      size: {
        xxs: 'size-5 rounded-xs',
        xs: 'size-6 rounded-sm',
        sm: 'size-8 rounded-sm',
        md: 'size-10 rounded-lg',
        lg: 'size-12 rounded-lg',
        xl: 'size-14 rounded-xl',
        '2xl': 'size-[3.875rem] rounded-xl',
      },
      color: {
        white: 'bg-white border-tertiary',
        clear: '',
        gray: 'bg-utility-gray-100',
        brand: 'bg-utility-brand-100',
        'brand-secondary': 'bg-utility-brand-secondary-100',
        error: 'bg-utility-error-100',
        warning: 'bg-utility-warning-100',
        success: 'bg-utility-success-100',
        'blue-light': 'bg-utility-blue-light-100',
        blue: 'bg-utility-blue-100',
        indigo: 'bg-utility-indigo-100',
        purple: 'bg-utility-purple-100',
        violet: 'bg-utility-violet-100',
        fuchsia: 'bg-utility-fuchsia-100',
        cyan: 'bg-utility-cyan-100',
        lime: 'bg-utility-lime-100',
        pink: 'bg-utility-pink-100',
        orange: 'bg-utility-orange-100',
        transparent: 'bg-transparent border-transparent',
      },
    },
  },
);
